/*eslint-disable */
import dayjs from "dayjs";
import { isSuperAdmin, getLoggedInUserEmail } from '../../helpers/user'

const START_TIME = 'startTime';
const END_TIME = 'endTime';
const GUID = 'guid';
const LIMIT = 'limit';
const HTTP_METHOD = 'method';
const URL='url';
const USER_ID = 'userid';
const EMAIL = 'email';
const DETAIL_TYPE = 'detailType';

export const GET_METHOD = { label: 'GET', value: 'GET' };

export const POST_METHOD = { label: 'POST', value: 'POST' };

export const PUT_METHOD = { label: 'PUT', value: 'PUT' };

export const DELETE_METHOD = { label: 'DELETE', value: "DELETE" };

export const PATCH_METHOD = { label: 'PATCH', value: "PATCH" };

export const LOG = { label: 'log', value: "log" };

export const ERROR = { label: 'error', value: "error" };

export const ALL = { label: 'all', value: "all" };

export const HTTP_METHODS = [
    GET_METHOD,
    POST_METHOD,
    PUT_METHOD,
    DELETE_METHOD,
    PATCH_METHOD

];

export const DETAIL_TYPES = [
    LOG,
    ERROR
];

export const COLUMN_IDS = [];

const TWO_MONTHS_BEFORE_DATE = dayjs(new Date().setMonth(new Date().getMonth() - 1));

export const SIX_MONTHS_BEFORE_DATE = dayjs(new Date().setMonth(new Date().getMonth() - 6));

export const INITIAL_FILTERS = {
    [START_TIME]: TWO_MONTHS_BEFORE_DATE,
    [END_TIME]: dayjs(new Date()), 
    [GUID]: "", 
    [LIMIT]: "", 
    [HTTP_METHOD]: "", 
    [URL]: "",
    [EMAIL]: isSuperAdmin() ? '': getLoggedInUserEmail(),
    [USER_ID]: "",
    [DETAIL_TYPE]: ALL.id,
};